import React from 'react';
import { PayloadForm } from '../../components';
import { BlockContainer } from '../../components/layouts';
import type { Form as FormType, PagesQuery } from '../../graphql/generated/schema';
import type { ExtractLayoutType, SharedBlockType } from '../types';
import styles from './styles.module.scss';

export const Form: React.FC<SharedBlockType & ExtractLayoutType<PagesQuery, 'FormBlock'>> = ({
  form,
  blockSettings,
}) => (
  <BlockContainer
    blockSettings={blockSettings}
  >
    <PayloadForm
      form={form as FormType}
      submitButtonClassName={styles.submitButton}
    />
  </BlockContainer>
);
